import slugify from 'slugify';

class Building {
  constructor(data) {
    this.name = String(data.name); // String (It is ID of buildings as well)
    this.id = slugify(this.name, { lower: true });
    this.active = Boolean(data.active); // If building is accessible (works only if there are more than one building in the investment)
    this.floors = data.floors; // Floors class
    this.spritespin = {
      framesURL: {
        day: String(data.spritespin.framesURL.day), // String with sprite
        dayMobile: String(data.spritespin.framesURL.dayMobile), // String with sprite
        night: String(data.spritespin.framesURL.night), // (at night).
      },
      framesPerRow: Number(data.spritespin.framesPerRow), // How much frames are in each row
      frames: Number(data.spritespin.frames), // Number (1 - Infinity)
      breakpoints: [...data.spritespin.breakpoints], // Array of frames at which spinner stops
      points: [...data.spritespin.points], // Array of objects with name and cords for particular breakpoint
      maps: [...data.spritespin.maps], // Array of svg maps. Index in array = index of breakpoint
      windroseInitialRotation: Number(data.spritespin.windroseInitialRotation), // Number (0 - 360 deg)
      sense: Boolean(data.spritespin.reverse) === true ? -1 : 1, // Boolean
      frameTime: Number(data.spritespin.frameTime) || 40, // Spin speed
    };
  }
}

export default Building;
